module.exports = __webpack_public_path__ + "static/img/cocina_18.60628ec1.png";